import { type SupportedLocaleMap } from '@zep-us/i18n';
import { Trans, useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useLocale, useViewport } from '@/hooks';
import { Button } from '@/ui_v3';
import { UpsellFeatureIntro } from '../FeatureUpsellModal';
const GUIDE_IMAGES: SupportedLocaleMap<'ko' | 'en' | 'ja' | 'id' | 'th'> = {
  ko: '/assets/ai-tutor/modal/ai-tutor-ko.webp',
  en: '/assets/ai-tutor/modal/ai-tutor-en.webp',
  ja: '/assets/ai-tutor/modal/ai-tutor-ja.webp',
  id: '/assets/ai-tutor/modal/ai-tutor-id.webp',
  th: '/assets/ai-tutor/modal/ai-tutor-th.webp'
};
export const AiTutorInstallIntro = ({
  onStart,
  showAddButton = true
}: {
  onStart?: VoidFunction;
  showAddButton?: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const {
    isMobile
  } = useViewport();
  const {
    locale
  } = useLocale();
  return <UpsellFeatureIntro imageSrc={GUIDE_IMAGES[locale] ?? GUIDE_IMAGES.en} imageAlt="AI Tutor" title={<Trans t={t} i18nKey="build:aiTutorIntro.title" components={{
    br: <br />,
    Strong: <strong className="text-strong" />
  }} />} description={t('build:aiTutorIntro.description')} notices={[t('build:aiTutorIntro.notice1'), t('build:aiTutorIntro.notice2')]} footnote={t('build:aiTutorIntro.limitation')} middleSlot={isMobile && showAddButton ? <Button className="w-full" intent="strong" size="md" onClick={() => {
    logger.track('click_build_ai_tutor_mobile_intro_finish');
    onStart?.();
  }}>
            {t('build:aiTutorIntro.addButton')}
          </Button> : null} data-sentry-element="UpsellFeatureIntro" data-sentry-component="AiTutorInstallIntro" data-sentry-source-file="AiTutorInstallIntro.tsx" />;
};